import React, { useState, type SyntheticEvent } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { DataGridPro, type GridColDef } from "@mui/x-data-grid-pro";

const createRows = (count: number) => {
  return Array.from({ length: count }, (_, index) => ({
    id: index + 1,
    name: `User ${index + 1}`,
    email: `user${index + 1}@example.com`,
  }));
};

const TabsDataGrid: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "email", headerName: "Email", width: 250 },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
        sx={{ mb: "6px" }}
      >
        <Tab label="Tab 1" />
        <Tab label="Tab 2" />
        <Tab label="Tab 3" />
      </Tabs>

      {value === 0 && (
        <Box
          sx={{
            width: "100%",
            minHeight: 630,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DataGridPro
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            rows={createRows(10)}
            columns={columns}
            pagination
            pageSizeOptions={[10, 25, 50, 100]}
          />
        </Box>
      )}

      {value === 1 && (
        <Box
          sx={{
            width: "100%",
            minHeight: 630,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DataGridPro
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            rows={createRows(20)}
            columns={columns}
            pagination
            pageSizeOptions={[10, 25, 50, 100]}
          />
        </Box>
      )}

      {value === 2 && (
        <Box
          sx={{
            width: "100%",
            maxHeight: 630,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DataGridPro
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            rows={createRows(30)}
            columns={columns}
            pagination
            pageSizeOptions={[10, 25, 50, 100]}
          />
        </Box>
      )}
    </Box>
  );
};

export default TabsDataGrid;
